import gsap from "gsap";

const setNewsTab = () => {
  const triggers = document.querySelectorAll('.js-news-tab');
  let activeTrigger = document.querySelector('.js-news-tab.is-active');
  let activeCotent = document.querySelector('.js-news-tab-content.is-open');

  triggers.forEach((el) => {
    el.addEventListener('click', () => {
      activeTrigger.classList.remove('is-active');
      activeTrigger = el;
      activeTrigger.classList.add('is-active');

      gsap.set(activeCotent, {
        display: 'none',
      })

      const id = el.getAttribute('data-id');
      activeCotent = document.querySelector('#' + id);

      gsap.set(activeCotent, {
        display: 'block'
      })
      gsap.fromTo(activeCotent,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          ease: 'circ.Out',
          duration: 0.5,
        }
      )
    })
  })
}

export default setNewsTab;